// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"xp-z","badgeLink":"yp-z","category":"zp-z"};